import { useDispatch, useSelector } from "react-redux";

import getPasswordSelector from "../../selectors/ClientSelectors/getPasswordSelector";
import setPasswordAction from "../../actions/ClientActions/setPasswordAction";
import { useCallback } from "react";

export function useClientPassword() {
    const password = useSelector((state: Store) => getPasswordSelector(state));
    const dispatch = useDispatch();
    const setPassword = useCallback((text: string) => dispatch(setPasswordAction(text)), [dispatch]);
    return { password, setPassword };
}
